require('bootstrap/dist/css/bootstrap.min.css')
require('fork-awesome/css/fork-awesome.min.css')
require('ionicons/css/ionicons.min.css')
require('prismjs/prism')
require('prismjs/themes/prism.css')
require('prismjs/components/prism-wiki')
require('prismjs/components/prism-haskell')
require('prismjs/components/prism-go')
require('prismjs/components/prism-typescript')
require('prismjs/components/prism-jsx')
require('prismjs/components/prism-makefile')
require('prismjs/components/prism-gherkin')
require('highlight.js/styles/github-gist.css')
require('emojify.js/dist/css/basic/emojify.min.css')
require('../css/github-extract.css')
require('../css/markdown.css')
require('../css/extra.css')
require('../css/slide-preview.css')
require('../css/font.css')
require('../css/site.css')
const $ = require('jquery')
window.jQuery = $
window.$ = $
require('bootstrap')
require('gist-embed/gist-embed.min')
